import { createAction, props } from '@ngrx/store';
import {
	CustomerNdcDestinationSearchModel,
	SearchResponse,
	CustomerNdcDestinationModel,
	CreateCustomerNdcDestinationModel,
	UpdateCustomerNdcDestinationModel,
	FilterSearchRequest,
	BaseSearchColumnFilterModel
} from '@twrx-api-models';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';
import { IPreLoadModel } from '../../models/dto/pre-load-model';

export enum CustomerNdcDestinationActions {
	LoadCustomerNdcDestinations = '[Customer Ndc Destination] LoadCustomerNdcDestinations',
	CustomerNdcDestinationsLoaded = '[Customer Ndc Destination] CustomerNdcDestinationsLoaded',

	PreloadCustomerNdcDestination = '[Customer Ndc Destination] PreloadCustomerNdcDestination',
	CustomerNdcDestinationPreloaded = '[Customer Ndc Destination] CustomerNdcDestinationPreloaded',
	PreloadCustomerNdcDestinationNotFound = '[Customer Ndc Destination] PreloadCustomerNdcDestinationNotFound',

	LoadCustomerNdcDestinationById = '[Customer Ndc Destination] LoadCustomerNdcDestinationById',
	LoadCustomerNdcDestinationLoaded = '[Customer Ndc Destination] LoadCustomerNdcDestinationLoaded',
	LoadCustomerNdcDestinationNotFound = '[Customer Ndc Destination] LoadCustomerNdcDestinationNotFound',

	CreateCustomerNdcDestination = '[Customer Ndc Destination] CreateCustomerNdcDestination',
	CustomerNdcDestinationCreated = '[Customer Ndc Destination] CustomerNdcDestinationCreated',

	UpdateCustomerNdcDestination = '[Customer Ndc Destination] UpdateCustomerNdcDestination',
	CustomerNdcDestinationUpdated = '[Customer Ndc Destination] CustomerNdcDestinationUpdated',

	DeleteCustomerNdcDestination = '[Customer Ndc Destination] DeleteCustomerNdcDestination',
	CustomerNdcDestinationDeleted = '[Customer Ndc Destination] CustomerNdcDestinationDeleted',

	StartCustomerNdcDestinationFileGeneration = '[Customer Ndc Destination] StartCustomerNdcDestinationFileGeneration',
	CustomerNdcDestinationFileGenerationStarted = '[Customer Ndc Destination] CustomerNdcDestinationFileGenerationStarted',

	ErrorOccurred = '[Customer Ndc Destination] ErrorOccurred'
}

export const loadCustomerNdcDestinations = createAction(
	CustomerNdcDestinationActions.LoadCustomerNdcDestinations,
	props<
		ActionRequestPayload<FilterSearchRequest<BaseSearchColumnFilterModel>>
	>()
);

export const CustomerNdcDestinationsLoaded = createAction(
	CustomerNdcDestinationActions.CustomerNdcDestinationsLoaded,
	props<
		ActionResponsePayload<SearchResponse<CustomerNdcDestinationSearchModel>>
	>()
);

export const preloadCustomerNdcDestination = createAction(
	CustomerNdcDestinationActions.PreloadCustomerNdcDestination,
	props<ActionRequestPayload<IPreLoadModel<number>>>()
);

export const CustomerNdcDestinationPreloaded = createAction(
	CustomerNdcDestinationActions.CustomerNdcDestinationPreloaded,
	props<ActionResponsePayload<IPreLoadModel<CustomerNdcDestinationModel>>>()
);

export const preloadCustomerNdcDestinationNotFound = createAction(
	CustomerNdcDestinationActions.PreloadCustomerNdcDestinationNotFound
);

export const loadCustomerNdcDestinationById = createAction(
	CustomerNdcDestinationActions.LoadCustomerNdcDestinationById,
	props<ActionRequestPayload<number>>()
);

export const loadCustomerNdcDestinationLoaded = createAction(
	CustomerNdcDestinationActions.LoadCustomerNdcDestinationLoaded,
	props<ActionResponsePayload<CustomerNdcDestinationModel>>()
);

export const loadCustomerNdcDestinationNotFound = createAction(
	CustomerNdcDestinationActions.LoadCustomerNdcDestinationNotFound
);

export const createCustomerNdcDestination = createAction(
	CustomerNdcDestinationActions.CreateCustomerNdcDestination,
	props<ActionRequestPayload<CreateCustomerNdcDestinationModel>>()
);

export const CustomerNdcDestinationCreated = createAction(
	CustomerNdcDestinationActions.CustomerNdcDestinationCreated
);

export const updateCustomerNdcDestination = createAction(
	CustomerNdcDestinationActions.UpdateCustomerNdcDestination,
	props<ActionRequestPayload<UpdateCustomerNdcDestinationModel>>()
);

export const CustomerNdcDestinationUpdated = createAction(
	CustomerNdcDestinationActions.CustomerNdcDestinationUpdated
);

export const deleteCustomerNdcDestination = createAction(
	CustomerNdcDestinationActions.DeleteCustomerNdcDestination,
	props<ActionRequestPayload<number>>()
);

export const CustomerNdcDestinationDeleted = createAction(
	CustomerNdcDestinationActions.CustomerNdcDestinationDeleted
);

export const errorOccurred = createAction(
	CustomerNdcDestinationActions.ErrorOccurred
);
